import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sku.out-of-stock-confirm-modal.title',
    defaultMessage: 'Confirm cancellation',
  },
  body: {
    id: 'sku.out-of-stock-confirm-modal.body',
    defaultMessage:
      "All items in this order are out of stock. We'll notify the customer that you've cancelled the order. You will not receive a payout for the order.",
  },
  goBack: {
    id: 'sku.out-of-stock-confirm-modal.go-back',
    defaultMessage: 'Go back',
  },
});
